module.exports = __webpack_public_path__ + "img/Tips.6a0bc158.png";